import React, { useEffect, useState } from 'react';
import { getIsAuthenticated, getSecondaryToken, signIn } from '../../services/auth';
import Loader from '../loader.js';
import { loadGSGScript } from '../../services/load-gsg-scripts.js';
import AlertService from '../alert-service/alert-service.js';

GSGDirectChargesWidget.propTypes = {
};

function GSGDirectChargesWidget() {
    const [language, setLanguage] = useState("en");
    const [loading, setLoading] = useState(true); // Loader state
    const [isAuthenticated, setIsAuthenticated] = useState(false);//useSelector((state) => state?.user ?? null);

    useEffect(() => {
        const checkAuthStatus = async () => {
            const authStatus = await getIsAuthenticated();
            setIsAuthenticated(authStatus);
            setLoading(false);
            if (authStatus) {
                initializeGSG(); // Initialize only after authentication is confirmed
            }
            else {
                signIn();
            }
        };
        checkAuthStatus();
    }, []);

    useEffect(() => {
        const detectLanguageChange = () => {
            const detectedLang = document.documentElement.lang || "en";
            if (detectedLang !== "es") {
                setLanguage("en");
            } else {
                setLanguage(detectedLang);
            }
        };

        detectLanguageChange();

        const observer = new MutationObserver(() => detectLanguageChange());
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });

        return () => observer.disconnect();
    }, [loading]);

    const initializeGSG = async () => {
        try {
            await loadGSGScript(process.env.REACT_APP_GSG_DIRECT_CHARGES_SCRIPT, "DirectCharge"); // Load the script and wait for GSGWidget to initialize
            attachGSGDirectCharge();
        } catch (error) {
            console.error("Error initializing GSGWidget:", error);
        }
    };

    const attachGSGDirectCharge = () => {
        window.DirectCharge.attach({
            site: 'ca-sanbernardino/direct-charge',
            elementSelector: '#gsg-direct-charge',
            environment: process.env.REACT_APP_GSG_ENVIRONMENT,
            language: language,
            // Secondary token will only work in a deployed environment, not locally.
            getJwt: () => getSecondaryToken().then(token => token),
            enableTestMode: false,
            initialPath: '/',
            onError: function (error) {
                console.error(error.message);
            },
        });
    };

    useEffect(() => {
        if (!loading && isAuthenticated) {
            initializeGSG();
        }
    }, [language]);


    if (loading) {
        // Render a loader while authentication is being checked
        return <Loader />;
    }

    return (
        <>
            <div className="container">
                <AlertService showGSG={true} showGlobal={false} siteName={"direct-charge"} />
            </div>
            <div className="gsg-container">
                <div className="container mt-5">
                    <div className="row">
                        <div id="gsg-direct-charge"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GSGDirectChargesWidget;
